import React, { useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import { Empty, Table } from "antd";
import TablePagination from "../../../components/Table/TablePagination";
import { BaseText } from "../../../components/Text/Label";
import { icon } from "../../../resource";
import moment from "moment";
import StatusBadge from "../../../components/Badge/StatusBadge";
import { MAP_STATUS_TOUR, MAP_STATUS_WORD_TOUR } from "../../../definitions/achievementStatus";
import { getHistoryAchievement } from "../../../datasource/AchievementDataSource";
import type { historyAchievementEntity } from "../../../entities/AchievementEntity";
import { CustomTableWrapper } from "../../ProductQuota/HistoryQuota";

function HistoryPage({ achievementId }: { achievementId: string }) {
  const [data, setData] = useState<historyAchievementEntity[]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await getHistoryAchievement(achievementId).then((res) => {
          setData(res);
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const renderStatus = (value?: string) =>
    value ? (
      <StatusBadge
        borderRadius='8px'
        label={
          value === "WAIT_APPROVE"
            ? "รอการตรวจสอบ"
            : MAP_STATUS_WORD_TOUR[value as keyof typeof MAP_STATUS_WORD_TOUR]
        }
        bgColor={MAP_STATUS_TOUR[value as keyof typeof MAP_STATUS_TOUR]}
      />
    ) : (
      <BaseText>-</BaseText>
    );

  const columns = [
    {
      title: "วันเวลาอัปเดต",
      dataIndex: "updateAt",
      key: "updateAt",
      render: (value: string) => (
        <BaseText>{moment(value).format("DD/MM/YYYY HH:mm")}&nbsp;น.</BaseText>
      ),
    },
    {
      title: "กิจกรรม",
      dataIndex: "activity",
      key: "activity",
      render: (v: string) => <BaseText>{v || "-"}</BaseText>,
    },
    { title: "ก่อนแก้ไข", dataIndex: "statusBefore", key: "statusBefore", render: renderStatus },
    { title: "หลังแก้ไข", dataIndex: "statusAfter", key: "statusAfter", render: renderStatus },
    {
      title: "ผู้ใช้งาน",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (v: string) => <BaseText>{v || "-"}</BaseText>,
    },
  ];

  return (
    <CustomTableWrapper style={{ margin: "22px 0px" }}>
      <Text fontSize={16} fontWeight={700}>
        ประวัติทำรายการความสำเร็จ
      </Text>
      <div style={{ marginTop: 22 }}>
        <Table
          loading={loading}
          scroll={{ y: 600 }}
          columns={columns}
          dataSource={data}
          pagination={false}
          locale={{
            emptyText: (
              <div style={{ display: "flex", justifyContent: "center", padding: "6%" }}>
                <Empty
                  image={icon.emptyHistoryPoint}
                  description={
                    <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                      ไม่มีรายการประวัติ
                    </Text>
                  }
                />
              </div>
            ),
          }}
        />
      </div>
    </CustomTableWrapper>
  );
}

export default HistoryPage;
